// extracted by mini-css-extract-plugin
export default {"new":"styles_new__CdsAi","btnTitle":"styles_btnTitle__gpCJ7","options":"styles_options__wtjvA","item":"styles_item__hXdKS","icon":"styles_icon__-GCVD"};